import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { CancelOutlined, Close, ExpandMore, QueryStats, Search } from '@mui/icons-material';
import TextInput from './common/TextInput';
import SelectInput from './common/SelectInput';
import { Transition } from '../pages/internal/ReturnSubmission';
import { stringOptions, searchColumns, dateOptions, booleanOptions } from '../util';

const Filters = ({ searchFields = [], showFilter = true, showClearBtn = true, useDefault = true, columns, searchFunction, advancedSearchFields = false, defaultExpanded = false }) => {
    const [open, setOpen] = useState(false);
    const [showClear, setShowClear] = useState(false);
    const [fields, setFields] = useState({});

    const defaultValue = {
        Start: 0,
        Length: 50,
        order: [
            // {
            //     column = 0,
            //     dir = "asc"|"desc"
            // }
        ],
        columns: [...searchColumns],
        search: {
            value: '',
        },
    };
    const [searchValues, setSearchValues] = useState(defaultValue);

    const search = async (values, { setSubmitting, resetForm }) => {
        try {
            setSubmitting(true);
            const rangeColumns = searchValues?.columns?.filter(({ search }) => Boolean(search?.value2));
            let columns = [...searchValues.columns];

            rangeColumns.map(({ search, ...data }) => {
                columns.push({ ...data, search: { ...search, operatorValue: 'LessThanOrEqual', value: search?.value2 } });
            });

            let payload = values;
            if (payload?.category) delete payload.category;
            if (payload?.institutionTypeId == '') delete payload.institutionTypeId;

            useDefault ? await searchFunction({ ...searchValues, columns }, closeSearchModal) : await searchFunction(payload);
            setShowClear(showClearBtn && true);
        } catch (err) {
            console.log(err);
        } finally {
            setSubmitting(false);
        }
    };

    const cancelSearch = async () => {
        try {
            useDefault ? await searchFunction(defaultValue, closeSearchModal) : await searchFunction({});
            setShowClear(false);
        } catch (err) {}
    };

    const closeSearchModal = () => {
        setOpen(false);
    };

    const handleChange = (name, value, key) => {
        let newColumns = [...searchValues.columns];
        let col = newColumns[key];
        col['search'][name] = value;
        newColumns[key] = col;
        setSearchValues({ ...searchValues, columns: newColumns });
    };

    useEffect(() => {
        let flds = {};
        searchFields.forEach(({ id }) => {
            flds[id] = '';
        });
        setFields(flds);
    }, [searchFields]);

    useEffect(() => {
        if (columns) {
            setSearchValues({
                ...searchValues,
                columns,
            });
        }
    }, [columns]);

    return (
        <>
            <Accordion defaultExpanded={defaultExpanded} style={{ boxShadow: 'none', borderRadius: '10px', border: '1px solid lightgrey', margin: '0 2rem' }} className="filters">
                <AccordionSummary className="p-0 pr-1 f-14" expandIcon={<ExpandMore />}>
                    Filters:
                </AccordionSummary>
                <AccordionDetails style={{ padding: 0 }}>
                    <div className="paper">
                        <Formik initialValues={{ ...fields }} onSubmit={search} enableReinitialize>
                            {({ isSubmitting, values }) => (
                                <Form>
                                    <Grid container spacing={3} paddingBottom={3} alignItems="flex-end">
                                        {searchFields?.map(
                                            ({ id = '', label = '', type = 'text', show = true, filterValue = '', ...form }, key) =>
                                                show && (
                                                    <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                                                        {type === 'select' ? (
                                                            <SelectInput id={id} label={label} {...form} filterValue={values[filterValue]} />
                                                        ) : (
                                                            <TextInput id={id} label={label} type={type} />
                                                        )}
                                                    </Grid>
                                                )
                                        )}
                                        {showFilter && (
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <Button variant="contained" type="submit" fullWidth startIcon={<Search />}>
                                                    {isSubmitting ? <CircularProgress size={15} color="inherit" /> : 'Filter'}
                                                </Button>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                            {advancedSearchFields && (
                                                <Button variant="outlined" onClick={() => setOpen(true)} fullWidth startIcon={<QueryStats />}>
                                                    Advanced Search
                                                </Button>
                                            )}
                                        </Grid>
                                        {showClear && (
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <Button variant="outlined" color="error" onClick={() => cancelSearch()} fullWidth startIcon={<CancelOutlined />}>
                                                    Clear Search
                                                </Button>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Dialog open={open} TransitionComponent={Transition} keepMounted maxWidth="md" fullWidth disableEscapeKeyDown>
                <Formik initialValues={{ ...searchValues }} onSubmit={search}>
                    {({ isSubmitting }) => (
                        <Form>
                            <DialogContent style={{ padding: '2rem 3rem 1rem', fontSize: '12px' }}>
                                <Grid container spacing={3} paddingBottom={3}>
                                    <Grid item xs={12} container alignItems={'center'} justifyContent={'space-between'}>
                                        <Typography fontWeight="bold" className="mb-0 f-18">
                                            Advanced Search
                                        </Typography>

                                        <IconButton disabled={isSubmitting} onClick={() => setOpen(false)}>
                                            <Close />
                                        </IconButton>
                                    </Grid>
                                    <Grid item container spacing={3} xs={12} alignItems="center" justifyContent={'center'}>
                                        <Grid item xs={4} className="text-center text-bold">
                                            Fields
                                        </Grid>
                                        <Grid item xs={4} className="text-center text-bold">
                                            Operators
                                        </Grid>
                                        <Grid item xs={4} className="text-center text-bold">
                                            Value
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                    {advancedSearchFields &&
                                        searchValues?.columns?.map(({ data = '', name = '', search }, key) => (
                                            <Grid item container spacing={3} xs={12} key={key} alignItems="center">
                                                <Grid item xs={4}>
                                                    <b>{name}:</b>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <SelectInput
                                                        id={`${data}-operator`}
                                                        field="code"
                                                        fieldDisplay="label"
                                                        placeholder={'Operators'}
                                                        options={search?.type == 'date' ? dateOptions : search?.optionType == 'boolean' ? booleanOptions : stringOptions}
                                                        customChange={(name, value) => {
                                                            handleChange('operatorValue', value, key);
                                                            if (value !== 'Between') handleChange('value2', '', key);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {search?.type == 'select' ? (
                                                        <SelectInput
                                                            id={data}
                                                            placeholder={name}
                                                            customChange={(name, value) => handleChange('value', value, key)}
                                                            field={search?.field || 'code'}
                                                            fieldDisplay={search?.fieldDisplay || 'label'}
                                                            options={search?.options || []}
                                                        />
                                                    ) : (
                                                        <TextInput
                                                            id={data}
                                                            value={search.value}
                                                            preventFormikSetValue
                                                            placeholder={name}
                                                            customChange={(name, value) => handleChange('value', value, key)}
                                                            type={search?.type || 'text'}
                                                        />
                                                    )}
                                                    {search?.operatorValue == 'GreaterThanOrEqual' && search?.type == 'date' && (
                                                        <TextInput
                                                            id={data + '2'}
                                                            preventFormikSetValue
                                                            className="mt-1"
                                                            value={search?.value2 || ''}
                                                            type={'date'}
                                                            customChange={(name, value) => handleChange('value2', value, key)}
                                                        />
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider />
                                                </Grid>
                                            </Grid>
                                        ))}
                                </Grid>
                            </DialogContent>
                            <DialogActions className="pr-2 pb-1">
                                <Button variant="contained" color="secondary" disabled={isSubmitting} onClick={() => setOpen(false)}>
                                    Cancel
                                </Button>
                                <Button variant="contained" type="submit" startIcon={<Search />} disabled={isSubmitting}>
                                    {isSubmitting ? <CircularProgress size={15} color="inherit" /> : 'Filter'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default Filters;
